<section class="process-section" id="processus">
  <div class="container">
    <div class="section-header">
      <span class="section-badge">Comment ça fonctionne</span>
      <h2>De la comptabilité au conseil patrimonial en 3 étapes</h2>
      <p>Un processus fluide et entièrement automatisé pour générer des rapports professionnels</p>
    </div>

    <div class="process-step process-step-left fade-in-up">
      <div class="process-visual">
        <div class="visual-card">
          <div class="visual-icon">📁</div>
        </div>
      </div>
      <div class="process-connector">
        <div class="connector-line"></div>
        <div class="connector-dot">1</div>
      </div>
      <div class="process-content">
        <h3>Import et analyse intelligente</h3>
        <p>Importez le FEC, grand livre ou balance générale. Wealthlane analyse automatiquement votre bilan et compte de résultat, calcule les ratios clés et génère des commentaires comptables pertinents prêts à présenter au client</p>
        <div class="process-tags">
          <span class="process-tag">⚡ Import FEC</span>
          <span class="process-tag">🧠 Lecture IA</span>
          <span class="process-tag">📈 Ratios clés</span>
          <span class="process-tag">💼 Grands agrégats</span>
        </div>
      </div>
    </div>

    <div class="process-step process-step-right fade-in-up delay-1">
      <div class="process-content">
        <h3>Profil dirigeant & solutions sur-mesure</h3>
        <p>Questionnaire personnalisé pour comprendre les objectifs du dirigeant. L'IA génère automatiquement des recommandations patrimoniales parmi 50+ solutions (SCPI, holding, assurance-vie...) et propose une allocation intelligente adaptée à son profil de risque</p>
        <div class="process-tags">
          <span class="process-tag">👤 Profil dirigeant</span>
          <span class="process-tag">🎯 50+ solutions</span>
          <span class="process-tag">📊 Allocation IA</span>
          <span class="process-tag">⚖️ Profil de risque</span>
        </div>
      </div>
      <div class="process-connector">
        <div class="connector-line"></div>
        <div class="connector-dot">2</div>
      </div>
      <div class="process-visual">
        <div class="visual-card">
          <div class="visual-icon">🎯</div>
        </div>
      </div>
    </div>

    <div class="process-step process-step-left fade-in-up delay-2">
      <div class="process-visual">
        <div class="visual-card">
          <div class="visual-icon">📄</div>
        </div>
      </div>
      <div class="process-connector">
        <div class="connector-line"></div>
        <div class="connector-dot">3</div>
      </div>
      <div class="process-content">
        <h3>Rapport patrimonial clé en main</h3>
        <p>Exportez en 2 clics un bilan patrimonial complet et personnalisé : analyse comptable, recommandations professionnelles et personnelles, stratégie d'allocation. Personnalisable section par section avant l'export final</p>
        <div class="process-tags">
          <span class="process-tag">📝 Export 2 clics</span>
          <span class="process-tag">✏️ Personnalisable</span>
          <span class="process-tag">🏢 Analyse pro</span>
          <span class="process-tag">👨‍💼 Analyse perso</span>
        </div>
      </div>
    </div>
  </div>
</section>

